var map = {
	"./collapse.svg": "0c20",
	"./css.svg": "0650",
	"./expand.svg": "6e85",
	"./figma.svg": "85bb",
	"./html.svg": "9987",
	"./react.svg": "d4a6",
	"./sass.svg": "6f1a",
	"./storybook.svg": "b666c",
	"./tailwind.svg": "6b5c",
	"./typescript.svg": "baa51",
	"./vscode.svg": "a8f6",
	"./vue.svg": "b596",
	"./xd.svg": "e1b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3647";